import { get } from 'lodash';
export var HeaderWidgetType;
(function (HeaderWidgetType) {
    HeaderWidgetType[HeaderWidgetType["LOGO"] = 0] = "LOGO";
    HeaderWidgetType[HeaderWidgetType["SEARCH_BAR"] = 1] = "SEARCH_BAR";
    HeaderWidgetType[HeaderWidgetType["ACC_MENU"] = 2] = "ACC_MENU";
    HeaderWidgetType[HeaderWidgetType["HELP_MENU"] = 3] = "HELP_MENU";
    HeaderWidgetType[HeaderWidgetType["CART_ICON"] = 4] = "CART_ICON";
    HeaderWidgetType[HeaderWidgetType["FK_GO_TO_HOME"] = 5] = "FK_GO_TO_HOME";
    HeaderWidgetType[HeaderWidgetType["SIDE_CONTAINER"] = 6] = "SIDE_CONTAINER";
    HeaderWidgetType[HeaderWidgetType["CENTER_CONTAINER"] = 7] = "CENTER_CONTAINER";
    HeaderWidgetType[HeaderWidgetType["PINCODE_DROPDOWN"] = 8] = "PINCODE_DROPDOWN";
    HeaderWidgetType[HeaderWidgetType["TITLE"] = 9] = "TITLE";
})(HeaderWidgetType || (HeaderWidgetType = {}));
export const getWidgetList = (props) => {
    return [
        { type: HeaderWidgetType.SIDE_CONTAINER, widgetList: getLHSWidgetList(props) },
        { type: HeaderWidgetType.CENTER_CONTAINER, widgetList: getCenterWidgetList(props) },
        { type: HeaderWidgetType.SIDE_CONTAINER, widgetList: getRHSWidgetList(props) }
    ];
};
const getCenterWidgetList = (props) => {
    const widgetList = [];
    const { minimal, isGrocery, isPincodeWidgetPresent } = props;
    widgetList.push({ type: HeaderWidgetType.LOGO });
    if (!minimal ||
        (minimal !== 'CHECKOUT' && minimal !== 'SURVEY' && minimal !== 'TRAVEL' && minimal !== 'TRAVEL_CHECKOUT'))
        widgetList.push({ type: HeaderWidgetType.SEARCH_BAR });
    if (minimal === 'TRAVEL')
        widgetList.push({ type: HeaderWidgetType.TITLE, extraProps: { Title: 'Travel' } });
    if (isGrocery && !minimal && isPincodeWidgetPresent)
        widgetList.push({ type: HeaderWidgetType.PINCODE_DROPDOWN });
    if (minimal !== 'CHECKOUT' && minimal !== 'SURVEY' && minimal !== 'TRAVEL_CHECKOUT')
        widgetList.push({ type: HeaderWidgetType.ACC_MENU });
    if (!minimal) {
        widgetList.push({ type: HeaderWidgetType.HELP_MENU });
        widgetList.push({ type: HeaderWidgetType.CART_ICON });
    }
    switch (minimal) {
        /** in case minimal variable is 'TRAVEL' add help menu */
        case 'TRAVEL':
            widgetList.push({ type: HeaderWidgetType.HELP_MENU });
            break;
        default:
            /** don't add help menu in widget list */
            break;
    }
    return widgetList;
};
const getRHSWidgetList = (props) => {
    const { abExperiments } = props;
    const fkHomeLogoLeft = get(abExperiments, 'fkHomeLogoLeft', false);
    return !fkHomeLogoLeft ? [{ type: HeaderWidgetType.FK_GO_TO_HOME }] : [];
};
const getLHSWidgetList = (props) => {
    const { abExperiments } = props;
    const fkHomeLogoLeft = get(abExperiments, 'fkHomeLogoLeft', false);
    return !!fkHomeLogoLeft ? [{ type: HeaderWidgetType.FK_GO_TO_HOME }] : [];
};
